import { IDVGItemDTO, IGenericDTO } from "coreframetypings/dto";
import { IReadOnlyPrinterStatic } from '#/DefaultViewExtensionInterfaces';
import { staticImplements } from '@/Components/@Decorator/StaticImplementsDecorator';
import Utilities from '@/Utility/Utilities';
import * as NumericTypeHelper from '@/Utility/NumericTypeHelper';
import Factory from '@/Factories/Factory';
import TypeConverter from '@/Utility/TypeConverter';

@staticImplements<IReadOnlyPrinterStatic>()
export default class NumericPrinter {

    public static print(item: IDVGItemDTO, value: string, row: IGenericDTO): HTMLElement {
        let span = document.createElement('span');
        let precision = this.getFloatingPrecision(item);

        span.textContent = NumericTypeHelper.toLocaleString(parseFloat(value), precision);

        return span;
    }

    public static isRelevant(item: IDVGItemDTO, value: string, row: IGenericDTO): boolean {
        //Nachkommastellen dürfen bei string nicht angezeigt werden
        return !TypeConverter.typeIsString(item.dotNetTypeName) && Utilities.isNumeric(value);
    }

    public static createToolTip(item: IDVGItemDTO, value: string, row: IGenericDTO): string {
        let precision = this.getFloatingPrecision(item);
        return NumericTypeHelper.toLocaleString(parseFloat(value), precision);
    }

    private static getFloatingPrecision(item: IDVGItemDTO): number | undefined {
        // Bei Ganzzahltypen muss immer 0 als FloatingPrecision zurückgegeben werden
        if (!Utilities.isNullOrUndefinedOrBlank(item.dotNetTypeName) &&
            TypeConverter.typeIsNonFloatingNumber(item.dotNetTypeName)) {
            return 0;
        } else {
            const parameter = Factory.parseUIGeneratorQuery(item.uiGenerator);
            return parameter.parameters?.floatingPrecision;
        }
    }
}